import React from 'react';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useMutation } from '@tanstack/react-query';
import { deleteUser } from '../../../services/admin/UsersService';
import { AxiosError } from 'axios';
import { showToast } from '../../../components/messages/ErrorAlert';
import firebaseErrorMessages from '../../../components/errorMessages/firebase';
import { Toast } from 'primereact/toast';

type RemoveUserButtonProps = {
  userID: string;
  toastRef: React.RefObject<Toast>;
  afterRemoval?: (date: Date) => void;
};

const RemoveUserButton = ({
  userID,
  toastRef,
  afterRemoval,
}: RemoveUserButtonProps) => {
  const disableUserResult = useMutation({
    mutationFn: () => {
      return deleteUser(userID ?? '');
    },
    onSuccess: (date) => {
      if (afterRemoval) {
        afterRemoval(date);
      }

      showToast(
        'success',
        toastRef,
        'Disable User',
        'User has been disabled successfully',
        3000
      );
    },

    onError: (error: AxiosError) => {
      const errorData = error.response?.data as { code: string };
      showToast(
        'error',
        toastRef,
        'Disable User Error',
        firebaseErrorMessages[errorData?.code] ||
          'An error occurred! please try again later',
        3000
      );
    },
  });

  const onClickRemove = () => {
    confirmDialog({
      message: 'Do you want to disable this user?',
      header: 'Disable Confirmation',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      accept: disableUserResult.mutate,
    });
  };

  return (
    <div>
      <Button
        onClick={onClickRemove}
        className="w-15rem bluwaiRed border-0 flex py-3"
      >
        {disableUserResult.isLoading && (
          <ProgressSpinner className="w-3rem h-3rem" />
        )}
        {!disableUserResult.isLoading && (
          <span className="mx-auto text-22px text-white">Disable</span>
        )}
      </Button>
      <ConfirmDialog />
    </div>
  );
};

export default RemoveUserButton;
